import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ListView, WingBlank, WhiteSpace, NavBar } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import CommonUtils from '../utils/CommonUtils';
import '../styles/KfLog.css';

class KfLog extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4
        };
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 40;
        this.setState({
            height
        })
        this.loadPageData(1, height)
    }

    handleRefreshClick = () => {
        this.loadPageData(1)
    }

    loadPageData = (pageNum) => {
        DataFetcher.kfLogs({
            pageNum,
            pageSize: 15,
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : []
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages
                })
            }
        })
    }

    onEndReached = (event) => {
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.map((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
            return data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        return (
            <WingBlank size='sm' key={rowId}>
                <div className='row'>
                    <div className='body'>
                        <div className='info'>
                            <div className='description word-ellipsis'>
                                {rowData.description}
                            </div>
                            <div className='remark word-ellipsis'>{rowData.reason}</div>
                        </div>
                    </div>
                    <div className='footer'>
                        <div className='order-no'>{rowData.orderNo}</div>
                        <div className='time'>{CommonUtils.shortenDateTime(rowData.createTime)}</div>
                    </div>
                </div>
            </WingBlank>
        )
    }

    render() {
        const {dataSource, isLoading} = this.state;
        return (
            <div className='page-kf-log'>
                <NavBar 
                    mode="light" 
                    rightContent={<i className='iconfont icon-shuaxin' style={{color:'black', fontSize: 22}} onClick={this.handleRefreshClick}></i>}
                >
                    操作记录
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
            </div>
        )
    }
}

export default KfLog;


// WEBPACK FOOTER //
// ./src/modules/KfLog.js